import { render } from "./DesgloseCostos.vue?vue&type=template&id=7c9505a2&scoped=true"
import script from "./DesgloseCostos.vue?vue&type=script&lang=js"
export * from "./DesgloseCostos.vue?vue&type=script&lang=js"

import "./DesgloseCostos.vue?vue&type=style&index=0&id=7c9505a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9505a2"]])

export default __exports__